import { useQuery } from '@tanstack/react-query'
import { settingsApi } from '@api/endpoints/settings'
import { MeasurementUnit } from '@/types/settings'

// Shared query key so every caller dedupes onto a single cached request for the
// user's preferences (the value rarely changes within a session).
export const MEASUREMENT_UNIT_QUERY_KEY = ['user-preferences'] as const

/**
 * Returns the user's current measurement system, defaulting to Imperial until
 * preferences load (matching the settings API default). Cached app-wide via
 * React Query, so using it in many components issues only one request.
 */
export function useMeasurementUnit(options?: { enabled?: boolean }): MeasurementUnit {
  const { data } = useQuery({
    queryKey: MEASUREMENT_UNIT_QUERY_KEY,
    queryFn: () => settingsApi.getUserPreferences(),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    // Off for pages a signed-out visitor can open: the request 401s, and the client answers a 401
    // without a session by sending the browser to /login.
    enabled: options?.enabled ?? true,
  })
  return data?.measurementUnit ?? MeasurementUnit.Imperial
}
